<template>
  <pf-background-image :src="backgroundImage" />

  <pf-login-page :title="$t('Accedi alla Webmail')" :brand-img-src="LogoSVG">
    <div>
      <header class="login-pf-header">
        <h1>{{ $t('Sito in manutenzione') }}</h1>
      </header>

      {{ $t('I nostri servizi online sono attualmente in manutenzione.') }}<br>
      {{ $t('Il sito tornerà in funzione al 100% tra pochi istanti, prova a ricaricare la pagina ora.') }}<br>
    </div>

    <pf-button variant="primary" large block :disabled="reloading" @click="reload">
      {{ $t('Ricarica') }}
      <div v-if="reloading" class="spinner spinner-xs" />
    </pf-button>
  </pf-login-page>
</template>

<style scoped>
.separator::before {
  display: block;
  content: '';
  width: 50%;
  margin: 20px auto;
  border-top: 1px solid #bbb;
}
</style>

<script lang="ts" setup>
import { sleep } from '@common/utils';
import { useLoginStore } from '@/store/login';
import { useAppStore } from '@/store/app';
import { onBeforeUnmount, onMounted } from 'vue';
import LogoSVG from '@/assets/logo.svg';
import { useFunctionRunningState } from '@common/use';

defineOptions({
  name: 'MaintenancePage',
});

let timer: number | undefined = undefined;

onMounted(() => {
  timer = window.setInterval(reload, 20000);
});

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer);
  }
});

const { isRunning: reloading, run: reload } = useFunctionRunningState(async() => {
  const app = useAppStore();
  const login = useLoginStore();

  try {
    await login.refresh();
    if (!app.maintenance) {
      location.reload();
    } else {
      await sleep(5000);
    }
  } catch (e) {
    await sleep(5000);
  }
}, { preventMultiple: true });

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const backgroundImage = 'https://www.artera.net/wp-content/uploads/2018/05/main-photo.jpg';
</script>
